import { memo, Fragment } from 'react';
import PropTypes from 'prop-types';

import Logo from '@hiredigital/ui/Logo';
import ButtonLink from '@hiredigital/ui/Button/NextButtonLink';
import Link from '@components/Link';

import Styles from './Profile.module.scss';

const ResumeHeader = memo(({ user, hasToken }) => {
  return (
    <Fragment>
      {/* START PRINT STYLES */}
      <div className={Styles.printLogoContainer}>
        <Logo className={Styles.logo} type={Logo.Type.BLACK} site={'3'} />
        <div className={Styles.printActionText}>
          <p>{`Work With High Performing Talent On Demand`}</p>
          <p
            className={
              Styles.printNumber
            }>{`${process.env.NEXT_PUBLIC_CONTACT_EMAIL} | 1 (617) 528-0943`}</p>
        </div>
      </div>
      {/* END PRINT STYLES */}
      <div className={Styles.logoContainer}>
        <Link className={Styles.logoLink} to='/'>
          <Logo className={Styles.logo} type={Logo.Type.WHITE} site={'3'} />
        </Link>

        <div className={Styles.actionContainer}>
          <p className={Styles.actionText}>{`Work With High Performing Talent On Demand`}</p>
          {hasToken ? (
            <ButtonLink
              type={ButtonLink.Type.WHITE}
              className={Styles.btnActionWork}
              title='Work With Talent'
              href={`${process.env.NEXT_PUBLIC_SITE_URL}/login?next=${encodeURIComponent(
                process.env.NEXT_PUBLIC_APP_URL + `/briefs/`
              )}`}
              external>
              {`Work With Talent`}
            </ButtonLink>
          ) : (
            <ButtonLink
              type={ButtonLink.Type.WHITE}
              className={Styles.btnActionWork}
              title='Work With Talent'
              href={{
                pathname: '/get-started',
                query: { talentName: user.username },
              }}>
              {`Work With Talent`}
            </ButtonLink>
          )}
        </div>
      </div>
    </Fragment>
  );
});

ResumeHeader.propTypes = {
  className: PropTypes.string,
};

export default ResumeHeader;
